import { PostEditorContextEnum } from '../models/post-editor';
import { useCallback, useContext } from 'react';
import { AppContext } from '../providers/AppProvider';
import { OnboardingContext } from '../modules/Onboarding/states/OnboardingProvider';
import { gqlCompleteStep } from '../modules/Onboarding/states/reducers/gotoStep.reducer';
import { useSeeOnboardingStepMutation } from '../models/graphql';
import { isPostEditorActive } from '../modules/Onboarding/helpers/isPostEditorActive';
import { ProgresStepType } from '../modules/Onboarding/constants/content';
import { useUserData } from './useUserData';

type UseClosePostEditorResultType = {
  closePostEditor: VoidFunction;
};
export const useClosePostEditor = (): UseClosePostEditorResultType => {
  const { setPostEditorContext, postEditorContext } = useContext(AppContext);
  const { userData } = useUserData();
  const { id: userId } = userData || { id: undefined };
  const { state, showOnboarding } = useContext(OnboardingContext);
  const { version, stepsCompleted, progress } = state;
  const [markAsSeenMuation] = useSeeOnboardingStepMutation();

  const shouldCompletePostEditor = progress.find(
    step => step.route === '' && !step.completed && step.key === `v${version}_progress_post_editor`
  );

  const closePostEditor: VoidFunction = useCallback(() => {
    if (
      isPostEditorActive(postEditorContext) &&
      showOnboarding &&
      !stepsCompleted &&
      shouldCompletePostEditor &&
      userId
    ) {
      const key: ProgresStepType['key'] = `v${version}_progress_post_editor`;
      gqlCompleteStep(markAsSeenMuation, key, userId);
    }
    setPostEditorContext({
      type: PostEditorContextEnum.undefined
    });
  }, [
    markAsSeenMuation,
    stepsCompleted,
    postEditorContext,
    setPostEditorContext,
    shouldCompletePostEditor,
    showOnboarding,
    version,
    userId
  ]);

  return {
    closePostEditor
  };
};
